<template>
  <div
    class="full-layout-shell"
    :class="contentWidth === 'boxed' ? 'container p-0' : null"
  >
    <div class="full-layout-shell__content">
      <router-view />
    </div>
    <footer
      v-if="!$route.meta.hideFooter"
      class="full-layout-shell__footer"
    >
      <div class="full-layout-shell__footer-inner">
        <span>Tüm Hakları Saklıdır © {{ new Date().getFullYear() }} DİKO ®</span>
        <legal-footer-links />
      </div>
    </footer>
  </div>
</template>

<script>
import useAppConfig from '@core/app-config/useAppConfig'
import LegalFooterLinks from '@/components/legal/LegalFooterLinks.vue'

export default {
  components: {
    LegalFooterLinks,
  },
  setup() {
    const { contentWidth } = useAppConfig()
    return { contentWidth }
  },
}
</script>

<style lang="scss">
.full-layout-shell {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.full-layout-shell__content {
  flex: 1 0 auto;
}

.full-layout-shell__footer {
  flex: 0 0 auto;
  padding: 1rem 1.5rem;
  border-top: 1px solid #ebe9f1;
  background: #fff;
}

.full-layout-shell__footer-inner {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  max-width: 1200px;
  margin: 0 auto;
  gap: 1rem;
  color: #6e6b7b;
}

body.dark-layout {
  .full-layout-shell__footer {
    border-top-color: #3b4253;
    background: #283046;
  }

  .full-layout-shell__footer-inner {
    color: #b4b7bd;
  }
}

@media (max-width: 767.98px) {
  .full-layout-shell__footer-inner {
    display: block;
  }
}

@media print {
  .full-layout-shell__footer {
    display: none;
  }
}
</style>
